import { apiClient } from "../../../base/ApiClient";

const BASE_URL = "/careplan/api/body-maps/";


export const createBodyMap = async (payload) => {
  const res = await apiClient.post(BASE_URL, payload);
  return res.data;
};

export const getBodyMaps = async (clientID, page = 1, page_size = 5) => {
  const res = await apiClient.get(BASE_URL, {
    params: {
      client: clientID,
      page,
      page_size,
    },
  });
  return res.data;
};

export const getBodyMapById = async (id) => {
  const res = await apiClient.get(`${BASE_URL}${id}/`);
  return res.data;
};

export const updateBodyMap = async (id, payload) => {
  const res = await apiClient.put(`${BASE_URL}${id}/`, payload);
  return res.data;
};

export const deleteBodyMap = async (id) => {
  const res = await apiClient.delete(`${BASE_URL}${id}/`);
  return res.data;
};
